import React from 'react';

export class FaseNavButton extends React.Component {
    constructor(props) {
        super(props);

        this.gotoFaseClicked  = this.gotoFaseClicked.bind(this);
    }

    gotoFaseClicked()
    {
        //return; // disable click
        window.app.gotoFirstFasePage(this.props.fase);
    }

    render() {

        return (<div className={this.props.is_active ? "tool__fasenav__button_wrapper_full_active" : "tool__fasenav__button_wrapper_full"} onClick={this.gotoFaseClicked}>


                <div className={"tool__fasenav__button_label"} dangerouslySetInnerHTML={{__html: this.props.fase_name}}>

                </div>
                <div className={"tool__fasenav__button_icon"} style={{
                    "background-image": "url('/digibord/assets/svgs/fase" + this.props.fase + ".svg'"
                }}
                >

                </div>


            </div>

        );
    }

}
